import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAlert } from "../AlertContext";
import { fetchCreditDetails as getCreditDetails } from "../../functions/fetchCreditDetails";
const StoreContext = createContext();

const GlobalStateProvider = ({ children }) => {
  const { showAlert } = useAlert();
  const [creditData, setCreditData] = useState({});
  const [token, setToken] = useState(() => {
    return localStorage.getItem("token") || "";
  });

  const fetchCreditDetails = useCallback(() => {
    getCreditDetails(setCreditData, showAlert);
  }, [setCreditData, showAlert]);
  return (
    <StoreContext.Provider
      value={{
        creditData: creditData,
        setCreditData: setCreditData,
        fetchCreditDetails,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
export const useStoreValues = () => useContext(StoreContext);

export default GlobalStateProvider;
